import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import SimpleAuth from './components/SimpleAuth'
import DashboardContent from './components/Dashboard.jsx'
import './App.css'

function App() {
  const [user, setUser] = useState(null)
  const [session, setSession] = useState(null)
  const [checkingAuth, setCheckingAuth] = useState(true)

  // Check for existing session on mount - only check once
  useEffect(() => {
    const checkExistingAuth = async () => {
      try {
        const { getCurrentUser, fetchAuthSession } = await import('aws-amplify/auth')
        const userData = await getCurrentUser()
        const sessionData = await fetchAuthSession()
        
        // Check if we have a valid ID token
        if (sessionData.tokens?.idToken) {
          console.log('Found existing authenticated session')
          setUser(userData)
          setSession(sessionData)
        } else {
          console.log('No valid session tokens found')
        }
      } catch (err) {
        // No existing session - this is normal, user needs to log in
        console.log('No existing authentication (normal for first visit):', err.message || err.name)
      } finally {
        setCheckingAuth(false)
      }
    }
    
    checkExistingAuth()
  }, [])

  const handleAuthSuccess = (userData, sessionData) => {
    console.log('Authentication successful:', userData)
    setUser(userData)
    setSession(sessionData)
  }

  const handleSignOut = async () => {
    try {
      const { signOut } = await import('aws-amplify/auth')
      await signOut()
      setUser(null)
      setSession(null)
      // Force reload to clear any cached state
      window.location.reload()
    } catch (error) {
      console.error('Sign out error:', error)
      // Even if sign out fails, clear local state
      setUser(null)
      setSession(null)
      window.location.reload()
    }
  }

  if (checkingAuth) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        fontFamily: 'sans-serif'
      }}>
        <div>Checking authentication...</div>
      </div>
    )
  }

  if (!user) {
    return <SimpleAuth onAuthSuccess={handleAuthSuccess} />
  }

  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<DashboardContent user={user} session={session} onSignOut={handleSignOut} />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  )
}

export default App

